import React from 'react';
import UploadDocumentToPropertyForm from './UploadDocumentToPropertyForm';

export default function UploadDocumentToProperty() {
  return <UploadDocumentToPropertyForm />;
}
